import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"1em"} }

import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'copyrightBlock',
  setup(__props) {

const store = useStore();
const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["divider-with-text", { 'dark-mode': _unref(store).state.dark }])
    }, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)('keys.copyright.header')), 1)
    ], 2),
    _cache[0] || (_cache[0] = _createElementVNode("a", {
      class: "copyright-link",
      href: "https://fontawesome.com/",
      target: "_blank"
    }, "https://fontawesome.com/", -1)),
    _createTextVNode("  " + _toDisplayString(_unref(t)('keys.copyright.copyright1')), 1),
    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("a", {
      class: "copyright-link",
      href: "http://cliparts101.com/",
      target: "_blank"
    }, "http://cliparts101.com/", -1)),
    _createTextVNode("  " + _toDisplayString(_unref(t)('keys.copyright.copyright2')), 1),
    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("a", {
      class: "copyright-link",
      href: "http://getdrawings.com/",
      target: "_blank"
    }, "http://getdrawings.com/", -1)),
    _createTextVNode("  " + _toDisplayString(_unref(t)('keys.copyright.copyright3')), 1),
    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
    _cache[6] || (_cache[6] = _createElementVNode("a", {
      class: "copyright-link",
      href: "https://creazilla.com/",
      target: "_blank"
    }, "https://creazilla.com/", -1)),
    _createTextVNode("  " + _toDisplayString(_unref(t)('keys.copyright.copyright4')), 1),
    _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
    _createTextVNode(" " + _toDisplayString(_unref(t)('keys.copyright.copyright5')), 1)
  ]))
}
}

})